import { VideoSplitterV72 } from '@/components/VideoSplitterV72';

const VideoSplitterPage = () => {
  return <VideoSplitterV72 />;
};

export default VideoSplitterPage;